<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-md-12">
        <div class="card card-top-line">
          <ValidationObserver v-slot="{ passes }">
            <div class="header">
              <h2>Send Email and Messages</h2>
            </div>
            <div class="body add-fund-form">
              <form
                @submit.prevent="passes(sendnotificationSubmit)"
                id="basic-form"
              >
                <div class="body">
                  <ValidationProvider
                    name="type"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div class="country-dropdown">
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success:
                            sendnotificationType &&
                            sendnotificationType.length != 0 &&
                            !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="Country">Select Notification Type*</label>
                          <multiselect
                            placeholder=""
                            v-model="sendnotificationType"
                            :show-labels="false"
                            :options="notification_types"
                            :searchable="false"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="
                              sendnotificationType &&
                              sendnotificationType.length != 0 &&
                              !errors[0]
                            "
                          ></i>
                        </span>
                      </div>
                    </div>
                  </ValidationProvider>

                  <!-- Push Notification -->
                  <template v-if="sendnotificationType == 'Push Notification'">
                    <ValidationProvider
                      name="push_notification_title"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !push_notification.title,
                          success: push_notification.title,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="push_notification.title"
                            class="form-control"
                            id="push_notification"
                            placeholder="Company Name*"
                          />
                          <label for="push_notification" class="control-label">
                            Push Notification Title*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !push_notification.title"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="push_notification.title"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="push_notification_content"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !push_notification.content,
                          success: push_notification.content,
                        }"
                      >
                        <span class="float-label">
                          <textarea
                            type="text"
                            v-model="push_notification.content"
                            class="form-control"
                            id="push_notification_content"
                            placeholder="Company Name*"
                          ></textarea>
                          <label
                            for="push_notification_content"
                            class="control-label"
                          >
                            Push Notification Content*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !push_notification.content"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="push_notification.content"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="push_notification_image"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !push_notification.image,
                          success: push_notification.image,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="push_notification.image"
                            class="form-control"
                            id="push_notification_image"
                            placeholder="Company Name*"
                          />
                          <label
                            for="push_notification_image"
                            class="control-label"
                          >
                            Push Notification Image*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !push_notification.image"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="push_notification.image"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                  </template>
                  <!-- Push Notification -->

                  <!-- Email -->
                  <template v-if="sendnotificationType == 'Email'">
                    <ValidationProvider
                      name="email_notification_subject"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !email_notification.subject,
                          success: email_notification.subject,
                        }"
                      >
                        <span class="float-label">
                          <input
                            type="text"
                            v-model="email_notification.subject"
                            class="form-control"
                            id="email_notification"
                            placeholder="Company Name*"
                          />
                          <label for="email_notification" class="control-label">
                            Email subject*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !email_notification.subject"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="email_notification.subject"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                    <ValidationProvider
                      name="email_notification_content"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !email_notification.content,
                          success: email_notification.content,
                        }"
                      >
                        <label
                          for="email_notification_content"
                          class="control-label"
                        >
                          Email Content*
                        </label>
                        <span class="float-label">
                          <vue-editor
                            v-model="email_notification.content"
                          ></vue-editor>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !email_notification.content"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="email_notification.content"
                          ></i>
                        </span>
                      </div>
                    </ValidationProvider>
                  </template>
                  <!-- Email -->

                  <!-- SMS -->
                  <template v-if="sendnotificationType == 'SMS'">
                    <ValidationProvider
                      name="sms_notification_content"
                      rules="required"
                      v-slot="{ errors }"
                    >
                      <div
                        class="form-group"
                        :class="{
                          errors: errors.length && !sms_notification.content,
                          success: sms_notification.content,
                        }"
                      >
                        <span class="float-label">
                          <textarea
                            type="text"
                            v-model="sms_notification.content"
                            class="form-control"
                            @input="handleEditorInput"
                            @keydown="handleKeyDown"
                            id="sms_notification_content"
                            placeholder="Company Name*"
                          ></textarea>
                          <label
                            for="sms_notification_content"
                            class="control-label"
                          >
                            SMS Content*
                          </label>
                          <div class="line"></div>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && !sms_notification.content"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="sms_notification.content"
                          ></i>
                        </span>
                        <p class="text-right">
                          {{ sms_notification.content.length }}/320
                        </p>
                      </div>
                    </ValidationProvider>
                  </template>
                  <!-- SMS -->
                  <div class="country-dropdown">
                    <div class="form-group form-select multiselect-grp">
                      <span class="float-label">
                        <label for="Country">Select Source Country</label>
                        <multiselect
                          placeholder=""
                          v-model="sourceCountry"
                          :show-labels="false"
                          :options="sourceCountry_options"
                          :searchable="false"
                          track-by="id"
                          label="name"
                          multiple
                        >
                          <template slot="option" slot-scope="props">
                            <div class="option-title">
                              <span
                                class="mr-2"
                                :class="`flag-icon flag-icon-${props.option.isocode} fi-md fi-round`"
                              ></span>
                              <span>{{ props.option.name }}</span>
                            </div>
                          </template>
                        </multiselect>
                      </span>
                    </div>
                  </div>
                  <div class="country-dropdown">
                    <div class="form-group form-select multiselect-grp">
                      <span class="float-label">
                        <label for="Country">Select Remitter Group</label>
                        <multiselect
                          placeholder=""
                          v-model="remitterGroup"
                          :show-labels="false"
                          :options="remiter_options"
                          :searchable="false"
                          multiple
                        ></multiselect>
                      </span>
                    </div>
                  </div>

                  <div
                    class="d-flex justify-content-between flex-md-row flex-column"
                    v-if="sourceCountry.length > 0 && remitterGroup.length > 0"
                  >
                    <div class="form-group flex-fill">
                      <span class="cursor-pointer" @click="selectAll('add')">
                        Select All
                      </span>
                      <span class="cursor-pointer" @click="Addoptions = []">
                        Select None
                      </span>
                      <select
                        class="form-control"
                        v-model="Addoptions"
                        id="test"
                        multiple
                        size="10"
                      >
                        <option v-for="(item, index) in options" :key="index">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                    <div
                      class="select-action d-flex flex-md-column px-md-5 py-md-0 py-2 justify-content-center align-items-center"
                    >
                      <button
                        class="btn btn-primary d-flex align-items-center justify-content-center"
                        type="button"
                        @click="add"
                      >
                        <i class="icon-arrow-right font-weight-bold"></i>
                      </button>
                      <button
                        class="btn btn-primary d-flex align-items-center justify-content-center"
                        type="button"
                        @click="remove"
                      >
                        <i class="icon-arrow-left font-weight-bold"></i>
                      </button>
                    </div>
                    <div class="form-group flex-fill">
                      <span class="cursor-pointer" @click="selectAll('remove')">
                        Select All
                      </span>
                      <span class="cursor-pointer" @click="removeOptions = []">
                        Select None
                      </span>
                      <select
                        class="form-control"
                        v-model="removeOptions"
                        id="test"
                        multiple
                        size="10"
                      >
                        <option
                          v-for="(item, index) in selectedOptions"
                          :key="index"
                        >
                          {{ item }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex flex-column flex-md-row justify-content-center"
                >
                  <b-button
                    variant="secondary btn-mw"
                    size="lg"
                    @click="$router.back()"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    type="submit"
                    variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                    size="lg"
                  >
                    Submit
                  </b-button>
                </div>
              </form>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
const { VueEditor } = require("vue2-editor");
const { ValidationObserver, ValidationProvider } = require("vee-validate");
import "@/plugins/vee-validate";
import { mapState, mapGetters } from "vuex";
import { SOURCE_COUNTRY } from "../../../store/actions.type.js";
export default {
  name: "SendGroupRemitterEmail",
  components: {
    BreadCrumb,
    ValidationObserver,
    ValidationProvider,
    Multiselect: () => import("vue-multiselect"),
    VueEditor,
  },
  data() {
    return {
      sendnotificationType: "",
      push_notification: {
        title: "",
        content: "",
        image: "",
      },
      email_notification: {
        subject: "",
        content: "",
      },
      sms_notification: {
        content: "",
      },
      remitterGroup: [],
      sourceCountry: [],
      sourceCountry_options: [],

      options: [
        "Test 1",
        "Test 2",
        "Test 3",
        "Test 4",
        "Test 5",
        "Test 6",
        "Test 7",
        "Test 8",
        "Test 9",
      ],
      Addoptions: [],
      removeOptions: [],
      selectedOptions: [],

      notification_types: ["Email", "SMS", "Push Notification"],
      remiter_options: [
        "Red",
        "Basic",
        "Bronze",
        "Silver",
        "Silver-PLUS",
        "Gold",
        "Platinum",
        "TEST",
        "Dormant",
        "Not Transacted",
        "GREY - Unvalidated Profiles",
        "Expired",
        "Hibernate",
        "Bank Transferred Profiles",
        "Grey",
      ],
    };
  },
  methods: {
    sendnotificationSubmit() {
      console.log(this.remitterCredits);
      console.log(this.selectedOptions);
    },
    handleEditorInput() {
      if (this.sms_notification.content.length > 320) {
        // Truncate the content to the maximum allowed characters
        this.sms_notification.content = this.sms_notification.content.slice(
          0,
          320,
        );
      }
    },

    handleKeyDown(event) {
      if (
        this.sms_notification.content.length >= 320 &&
        event.key !== "Backspace"
      ) {
        // Prevent typing beyond the character limit
        event.preventDefault();
      }
    },
    selectAll(tab) {
      if (tab == "add") {
        this.options.map((item) => {
          this.Addoptions.push(item);
        });
      } else {
        this.selectedOptions.map((item) => {
          this.removeOptions.push(item);
        });
      }
    },
    add() {
      this.Addoptions.map((item) => {
        this.options.map((sub, index) => {
          if (sub == item) {
            this.options.splice(index, 1);
            this.selectedOptions.push(item);
          }
        });
      });
    },
    remove() {
      this.removeOptions.map((item) => {
        this.selectedOptions.map((sub, index) => {
          if (sub == item) {
            delete this.selectedOptions.splice(index, 1);
            this.options.push(item);
          }
        });
      });
    },
  },
  mounted() {
    this.$store.dispatch(SOURCE_COUNTRY).then((response) => {
      response.details.map((item) => {
        let countryData = {
          id: item.countryid,
          name: item.countryname,
          isocode: item.isocode.toLowerCase(),
        };
        this.sourceCountry_options.push(countryData);
      });
    });
  },
  computed: {
    ...mapGetters(["isLoading"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
  },
};
</script>
